import axios from 'axios';
// import {correlation}  from './Correlation.key';
import { ACCESS_TOKEN, CLIENT_NAME, TENANT_ID, WORKSPACE_ID } from '../constants/AdtechConstants';
import { FEATURE_CONTROL_RULE_ENDPOINT } from '../Common Components/service.urls';

// Use 'ajax' instead of axios for light and non-blocking API calls
// Works well when response is in JSON. 
// Not tested for non-JSON response.

let ajax = axios.create({
    headers : {
        // 'correlationId': correlation(),
        'Content-Type': 'application/json',
    }
});

function addLoader() { 
    const loader = document.getElementById('js-loader');
    const loaderCount = parseInt(loader.getAttribute('data-loader'));
    loader.setAttribute('data-loader', isNaN(loaderCount) ? 1 : loaderCount + 1);
}

function removeLoader() {
    const loader = document.getElementById('js-loader');
    const loaderCount = parseInt(loader.getAttribute('data-loader'));
    if(loaderCount > 1)
        loader.setAttribute('data-loader', loaderCount - 1);
    else
        loader.removeAttribute('data-loader');

}

ajax.interceptors.request.use(function (config) {
    //check for Bearer part in token
    config.headers = {...config.headers, 'Authorization':  localStorage.getItem(ACCESS_TOKEN)}
    let clientName = localStorage.getItem(CLIENT_NAME);
    config.params = {...config.params}
    if (!config.removeClientParams) config.params.clientName=clientName
    if ((config.method.toLowerCase() === 'post' || config.method.toLowerCase() === 'put') && config?.data && !config.url.includes(FEATURE_CONTROL_RULE_ENDPOINT)) {
      config.data.accountId = localStorage.getItem(TENANT_ID);
      config.data.subAccountId1 = localStorage.getItem(WORKSPACE_ID);
    }
    addLoader();
    return config;
}, function (error) {
    removeLoader();
    return Promise.reject(error);
});

// Add a response interceptor
ajax.interceptors.response.use(function (response) {
    removeLoader();
    return response;
}, function (error) {
    removeLoader();
    return Promise.reject(error);
});

export {ajax};
